import {useInfiniteQuery} from "@tanstack/react-query";

import {ITEMS_PER_PAGE} from "@/src/modules/core/utils/constants";

import {safelistingsService} from "../services";

type UseInfiniteSafelistingsParams = {
  filter?: Record<string, unknown>;
  sort?: string;
  enabled?: boolean;
  limit?: number;
};

export function useInfiniteSafelistings({
  filter = {},
  sort = "-created_at",
  enabled = true,
  limit = ITEMS_PER_PAGE,
}: UseInfiniteSafelistingsParams = {}) {
  const filterObj = Object.fromEntries(
    Object.entries(filter).filter(
      ([, v]) =>
        v !== undefined && v !== null && v !== "" && !(Array.isArray(v) && v.length === 0),
    ),
  ) as Record<string, string | number>;

  const options = {filter: filterObj, sort};

  const {data, ...query} = useInfiniteQuery({
    queryKey: ["safelistings", "infinite", options, limit],
    enabled,
    queryFn: ({pageParam = 0}) => {
      const page = {
        limit,
        offset: pageParam,
      };
      return safelistingsService.getSafelistings({...options, page});
    },
    getNextPageParam: (lastPage, pages) => {
      const loadedItems = pages.reduce((acc, p) => acc + p.data.length, 0);
      return loadedItems < lastPage.meta.total ? loadedItems : undefined;
    },
    initialPageParam: 0,
  });

  const safelistings = data?.pages.flatMap((p) => p.data) ?? [];
  const totalRecords = data?.pages[0]?.meta?.total ?? 0;

  return {
    safelistings,
    totalRecords,
    ...query,
  };
}
